import { render, staticRenderFns } from "./Encuesta.vue?vue&type=template&id=0c601bb0&"
import script from "./Encuesta.vue?vue&type=script&lang=js&"
export * from "./Encuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports